import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ControlsPlayIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M19.12 11.96L7.28 19.7V4.22L19.12 11.96ZM8.94 7.36V16.56L16 11.96L8.94 7.36Z" />
    </SvgIcon>
  );
});
